export default __webpack_public_path__ + "3638ee7d7150b4fca276c7e6acac3fc4.png";